module.exports = __webpack_public_path__ + "img/2.5eec569a.png";